<template lang="pug">
  .dh-ugc.xs-12(:class="classes")
    .title.text-center(v-if="showTitle")
      slot(name="title")
    
    .widget-wrap
      .dh-widget(ref="dhUgc")

    .cta-wrap.text-center(:class="{ hidden: version != 2}")
      button.mr-btn.btn-secondary.btn-fixed-width.xs-f-xsmall.max-at-tweak(ref="DashHudsonExplore" @click="tryItOn($refs.DashHudsonExplore)") Explore Similar Shades

</template>

<script>
  import { mapActions } from 'vuex';
  import { waitForElement } from "@utilities/dom";

  export default {
    name: "DashHudsonScriptInner",

    props: {
      location: {
        type: String,
        default: 'Dash Hudson Widget',
      },
      version: {
        type: Number,
        default: 1
      }
    },

    data() {
      return {
        noContent: true,
        checkFinished: false,
      };
    },

    computed: {
      classes() {
        let classes = [];

        classes.push('version-' + this.version);
        if (this.noContent) {
          classes.push('hidden');
        }

        return classes;
      },

      showTitle() {
        let hasTitle = false;
        if (this.$slots?.title?.[0]?.tag) {
          hasTitle = true;
        }

        return hasTitle && this.checkFinished && !this.noContent;
      },
    },

    mounted() {
      let tag = document.createElement('script');
      
      tag.setAttribute("src","https://cdn.dashhudson.com/web/js/product-carousel-embed.js");
      tag.setAttribute("type", "text/javascript");
      tag.setAttribute("data-name", "dhproduct-carousel");
      tag.setAttribute("data-id", "18947");
      tag.setAttribute("data-id-type", "brand_id");
      tag.setAttribute("data-row-size", "4");
      tag.setAttribute("data-gap-size", "8");
      tag.setAttribute("data-mobile-row-size", "3");
      tag.setAttribute("data-mobile-gap-size", "4");
      tag.setAttribute("data-autoplay", "true");

      this.$refs.dhUgc.appendChild(tag);
      this.checkIfContentExists();
    },

    methods: {
      ...mapActions('pdp', ['openPlaygroundModal']),

      async checkIfContentExists() {
        const interval = 200;
        const timeout = 5000;
        
        const [element, clickableEls] = await Promise.all([
          waitForElement(() => document.querySelector(`div.ls-slider-widget-container > div.ls-slider-container`), interval, timeout),
          waitForElement(() => document.querySelectorAll('div.aspect-ratio-box > div.js-click-image'), interval, timeout),
        ]);

        if (element) {
          this.noContent = false;
          this.checkFinished = true;
          /**
           * @description This is a workaround to track the click event on the Dash Hudson widget. It uses event bubbling
           * javascript to track the click event on the widget. The event is tracked when the widget is clicked.
           */
          const self = this;
          clickableEls.forEach((el) => {
            el.addEventListener('click', () => {
              self.mix_trackEvent(`${self.location} - Dash Hudson Widget Clicked`);
            });
          });
        } else {
          this.noContent = true;
          this.checkFinished = false;
        }
      },

      tryItOn(elementRef) {
        this.trackMREvent('DashHudson - Explore Similar Shades Clicked');
        this.openPlaygroundModal({
          returnFocusElement: elementRef,
        });
      }
    }
  };
</script>


<style scoped lang="stylus">
  .dh-ugc
    .title
      margin 1em
      
    .widget-wrap
      width 100%
      padding 0
      
    &.version-2
      background-color #F7F5F9
      
      .title
        margin-top 2.75em
      
      .cta-wrap
        padding 0.5em 5%
        padding-bottom 2.75em
        
        .btn-secondary
          border-color brand-color-1
          setcolor(brand-color-1)
          
          &:hover
          &:active
          &:focus
            background-color brand-color-1
            setcolor(color-white)
        
    @media mq-tablet-plus
      .widget-wrap
        padding 0 5%
      
</style>
